import React from 'react';
import { FileTextIcon } from 'lucide-react';
export function CategoryCardsSection() {
  return <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-1250">
      <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-8 flex flex-col items-center text-center hover:border-[#9B0137]/30 transition-colors" data-id="element-1251">
        <h2 className="text-xl font-bold text-navy mb-6" data-id="element-1252">
          <a href="#Breton_Gantry" className="hover:text-[#9B0137] transition-colors" data-id="element-1253">
            High-Speed 5-Axis Gantry Machining Centers
          </a>
        </h2>
        <a href="uploaded/files/Breton/Breton%20Machine%20Range_EN_11.2022.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 bg-[#9B0137] text-white font-bold uppercase text-sm rounded-md hover:bg-[#7a012b] transition-colors w-full" data-id="element-1254">
          <FileTextIcon className="w-4 h-4 mr-2" data-id="element-1255" />
          Breton Machine Range Brochure
        </a>
      </div>

      <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-8 flex flex-col items-center text-center hover:border-[#9B0137]/30 transition-colors" data-id="element-1256">
        <h2 className="text-xl font-bold text-navy mb-6" data-id="element-1257">
          <a href="/BretonGenesi.html" className="hover:text-[#9B0137] transition-colors" data-id="element-1258">
            Large Scale Polymer Additive Manufacturing
          </a>
        </h2>
        <a href="/BretonGenesi.html" className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#9B0137] text-[#9B0137] font-bold uppercase text-sm rounded-md hover:bg-[#9B0137] hover:text-white transition-colors w-full" data-id="element-1259">
          Breton Genesi
        </a>
      </div>
    </div>;
}